'use strict';

function getRules() {
    return {
        requesterName:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        timeLength:[
            {required: true, message: '只能输入数字并且不可为空', trigger: 'change,blur'},
        ],


    };
}
export {
    getRules
}
